import '../scss/atcui.scss';

export default function AtcTheme() {
    return null;
}
